import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Divider from '@narvar/nth-divider';
import cx from 'classnames';
import Icon from '../Icon';
import styles from './ClaimConfirmation.module.css';
import { Language } from '../Language';
import { logData } from '../../actions/analytics';
import { EVENT_VALUES, EVENTS } from '../../constants/noflake/noflakeSchema';

const generateLoopUrl = ({ order, email, zip }) => {
  const { origin, pathname, search } = window.location;
  const [retailerMoniker, application] = pathname.split('/').filter(Boolean);
  const urlPath = [retailerMoniker, application].join('/');
  const params = new URLSearchParams(search);
  params.set('order', order);
  if (email) {
    params.set('email', email);
  } else {
    params.set('bzip', zip);
  }
  params.set('init', 'true');
  return `${origin}/${urlPath}?${params.toString()}`;
};

const mapStateToProps = ({
  orderInfo: { currentOrderNumber } = {},
  landingPage: { landingForm: { email, zip } } = {},
  returnConfirmation: { primaryEmail } = {},
  language,
}) => ({
  language,
  email: primaryEmail,
  href: generateLoopUrl({ order: currentOrderNumber, email, zip }),
});

const ClaimConfirmation = ({ dispatch, language, email, href }) => (
  <div className={styles.container}>
    <div className={styles.inner_container}>
      <div aria-label="Transaction Success" role="alert">
        <Icon.SuccessCheckmark className="cta-icon" />
      </div>
      <h2
        className="step-4-header"
        dangerouslySetInnerHTML={{ __html: language['returns.step_4.header.claim'] }}
        ariaLive="polite"
      />
      <div className="confirmation-email-description">
        {language['returns.step_4.email_confirmation.claim'].replace(/\$email/g, email)}
      </div>
    </div>
    <Divider s={{ margin: '0' }} />
    <div className={cx(styles.loop_container, 'loop-container')}>
      <Language tagName="h4" langKey="returns.instruction.claim_loop_description" />
      <a
        href={href}
        className={styles.loop_link}
        onClick={() => {
          dispatch(
            logData({
              type: EVENTS.CLICK,
              value: EVENT_VALUES[EVENTS.CLICK].confirmation_page_loop_link,
            }),
          );
          window.location.href = href;
        }}
      >
        <Language langKey="returns.instruction.claim_loop_link_text" />
      </a>
    </div>
  </div>
);

ClaimConfirmation.propTypes = {
  dispatch: PropTypes.func.isRequired,
  language: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(ClaimConfirmation);
